<details-card [title]="title | transloco" [description]="description | transloco">
  <div actions>
    <button
      *ngIf="hasProductScopedWords && !hasNoWords && !allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="hasErrors || isApiRequestInProgress()"
      (click)="onResetToProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_RESET_TO_PRODUCT_DEFAULT' | transloco }}
    </button>
    <button
      *ngIf="!hasNoWords && allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="isApiRequestInProgress()"
      (click)="onDetachFromProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT' | transloco }}
    </button>
    <button
      *ngIf="!allWordsHaveProductScope"
      qai-link
      [disabled]="hasErrors || hasNoWords || isApiRequestInProgress()"
      class="header-action"
      (click)="saveAsProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_SAVE_AS_PRODUCT_DEFAULT' | transloco }}
    </button>
  </div>
  <div
    content
    class="content-container"
    *ngIf="cleanTranscriptWordsListControl"
  >
    <qai-word-list
      [buttonText]="buttonText | transloco"
      [formControl]="cleanTranscriptWordsListControl"
      [getError]="getFieldError"
      [actionsDisabled]="hasErrors || isDeleteInProgress()"
      [deleteActionsDisabled]="isCreateUpdateInProgress()"
      (wordRemoved)="onWordRemoved($event)"
    ></qai-word-list>
  </div>
</details-card>

<save-as-product-default-modal
  [open]="saveAsProductDefaultModalOpen"
  [moduleUuid]="moduleUuid"
  [keywordTitle]="keywordTitle | transloco"
  [networkRequestInProgress]="networkRequestInProgress"
  (confirm)="onSaveAsProductDefaultConfirm()"
  (closeModal)="onSaveAsProductDefaultModalClose()"
  (openChange)="saveAsProductDefaultModalOpen = $event"
></save-as-product-default-modal>
